import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  constructor(private router: Router,private auth: AuthService,private route:ActivatedRoute) { }

  ngOnInit() {
    document.body.id="page-top";
    $(document).ready(function(){
      $(document).find('#navar-toggle').on('click',function(){
        var isClass=$(document).find('.sidebar-wrapper').hasClass('smNav-none');
        if(isClass)
        {
         // $(document).find('.sidebar').show('slow');
          $(document).find('.sidebar-wrapper').removeClass('smNav-none');
        }
        else
        {
         // $(document).find('.sidebar').hide('slow');
          $(document).find('.sidebar-wrapper').addClass('smNav-none');
        }
      });
    });



  }


  logout(event)
  {
    event.preventDefault();
   /* this.auth.logoutUser().subscribe(data =>{
      if(data.error==null)
      {
        localStorage.clear();
        localStorage.removeItem('auth_name');
        localStorage.removeItem('user_role');
        localStorage.removeItem('branch');
        this.router.navigate(['/login']);
      }


    },(error)=>{
      localStorage.clear();
      localStorage.removeItem('auth_name');
      localStorage.removeItem('user_role');
      localStorage.removeItem('branch');
      this.router.navigate(['/login']);
    });*/
    localStorage.clear();
    this.router.navigate(['/login']);

  }

}
